import createTransition from 'shared-tokens/utils/createTransition';

export const mainCls = 'csa-fblogin';

export default {
  [mainCls]: {
    height: 40,
    background: '#4267B2',
    '@media (hover: hover)': {
      transition: createTransition(['background']),
      '&:hover': {
        background: '#2e467c !important',
      },
    },
  },
  [`${mainCls}__text`]: {
    lineHeight: '20px',
  },
};